// export const server = "http://localhost:8000";
export const server = "https://nato-cctv-solutions-server.vercel.app";
